<div class="mb-2" [style]="mainElementStyle">
  @if (!labelHide && labelValue.length > 0) {
  <ng-container>
    <label class="form-label">
      {{labelValue}}
      @if(isRequired){
      <sup>*</sup>
      }
    </label>
  </ng-container>
  }

  <mat-select [ngClass]="{
        inputClassPrimary: inputType === 'primary',
        inputClassPrimaryWithoutBorder: inputType === 'primaryWithoutBorder',
        inputClassSecondary: inputType === 'secondary',
        inputClassSecondaryWithoutBorder: inputType === 'secondaryWithoutBorder',
        inputClassWarning: inputType === 'warning',
        inputClassWarningWithoutBorder: inputType === 'warningWithoutBorder',
        inputClassSuccess: inputType === 'success',
        inputClassSuccessWithoutBorder: inputType === 'successWithoutBorder',
        inputClassDisabled: disabled
    }" [placeholder]="placeholder" [id]="id" [style]="selectStyle" [formControl]="$any(control)" ngDefaultControl
    [value]="value" [attr.disabled]="disabled" (selectionChange)="onValueChange($event)" multiple>

    @if(enableSearch) {
    <div class="search-container" (click)="stopPropagation($event)">
      <input type="text" class="search-input" [placeholder]="searchPlaceholder" [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()" (click)="stopPropagation($event)" (keydown)="stopPropagation($event)"
        (mousedown)="stopPropagation($event)" autocomplete="off">
    </div>
    }

    @if(filteredDataList.length > 0) {
    @for (item of filteredDataList; track item.id) {
    <mat-option [value]="item">{{item[labelFieldName]}}</mat-option>
    }
    } @else {
    <mat-option disabled>
      @if(enableSearch && searchText) {
      No results found
      } @else {
      No Data Found
      }
    </mat-option>
    }
  </mat-select>

  @if (errorMessage.length > 0) {
  <ng-container>
    <label class="error-label">
      {{errorMessage}}
    </label>
  </ng-container>
  }
</div>